import { mapListDirectionToClassName } from './helpers';

const List = ({ direction = 'row', children }) => (
  <div className={`integration__list ${mapListDirectionToClassName[direction]}`}>{children}</div>
);

export default List;
